(function () {
  if (!('animate' in Element.prototype)) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Returns whether an element is currently visible somewhere in the viewport.
   * @param {Element} el
   * @returns {boolean}
   */
  function isVisibleInViewport(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  /**
   * Finds the currently displayed image in the product page's media gallery,
   * respecting the selected variant's own image when it has one.
   * @param {Element} form
   * @returns {?Element}
   */
  function findProductPageImage(form) {
    var productRoot = form.closest('.js-product');
    if (!productRoot) return null;

    var mediaGallery = productRoot.querySelector('media-gallery');
    if (!mediaGallery) return null;

    var activeItem = mediaGallery.currentItem
      || mediaGallery.querySelector('.media-viewer__item.is-current-variant')
      || mediaGallery.querySelector('.media-viewer__item');

    return activeItem ? activeItem.querySelector('img, svg') : null;
  }

  /**
   * Finds the product image associated with the form that was submitted.
   * @param {Element} form
   * @returns {?Element}
   */
  function findSourceImage(form) {
    var card = form.closest('.card');
    if (card) {
      var cardImg = card.querySelector('.card__media img, .card__media svg');
      if (cardImg) return cardImg;
    }

    var quickAdd = form.closest('quick-add-drawer');
    if (quickAdd) {
      var quickAddImg = quickAdd.querySelector('.quick-add-info__media img');
      if (quickAddImg) return quickAddImg;
    }

    var productPageImg = findProductPageImage(form);
    if (productPageImg) return productPageImg;

    return null;
  }

  /**
   * Briefly re-triggers the header cart icon's existing shake animation.
   */
  function bounceCartIcon() {
    var cartIcon = document.getElementById('cart-icon');
    if (!cartIcon) return;

    cartIcon.style.setProperty('--shake-delay', '0s');
    cartIcon.classList.remove('header__icon--cart-shake');
    void cartIcon.offsetWidth; // Force reflow so the animation restarts.
    cartIcon.classList.add('header__icon--cart-shake');
  }

  /**
   * Plays a simple, low-motion feedback pulse on the source image for
   * prefers-reduced-motion users, instead of the flying animation.
   * @param {Element} sourceEl
   */
  function playReducedMotionFeedback(sourceEl) {
    sourceEl.animate(
      [{ opacity: 1 }, { opacity: 0.4 }, { opacity: 1 }],
      { duration: 300, easing: 'ease-out' }
    );
  }

  /**
   * Animates a clone of the product image flying from its on-screen
   * position toward the header cart icon (or a sensible fallback point).
   * @param {Element} sourceEl
   */
  function flyToCart(sourceEl) {
    if (reducedMotion) {
      playReducedMotionFeedback(sourceEl);
      return;
    }

    var startRect = sourceEl.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) return;

    var cartIcon = document.getElementById('cart-icon');
    var cartVisible = isVisibleInViewport(cartIcon);
    var endRect = cartVisible
      ? cartIcon.getBoundingClientRect()
      : { left: window.innerWidth - 32, top: 16, width: 24, height: 24 };

    var startX = startRect.left + startRect.width / 2;
    var startY = startRect.top + startRect.height / 2;
    var endX = endRect.left + endRect.width / 2;
    var endY = endRect.top + endRect.height / 2;
    var deltaX = endX - startX;
    var deltaY = endY - startY;
    var arcLift = Math.min(140, Math.abs(deltaY) * 0.5 + 60);

    var clone = sourceEl.cloneNode(true);
    clone.removeAttribute('class');
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cssText = [
      'position:fixed',
      'top:' + startRect.top + 'px',
      'left:' + startRect.left + 'px',
      'width:' + startRect.width + 'px',
      'height:' + startRect.height + 'px',
      'margin:0',
      'border-radius:8px',
      'object-fit:cover',
      'pointer-events:none',
      'z-index:9999',
      'will-change:transform,opacity'
    ].join(';');

    document.body.appendChild(clone);

    var animation = clone.animate(
      [
        { transform: 'translate(0px, 0px) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(' + deltaX * 0.55 + 'px, ' + (deltaY * 0.55 - arcLift) + 'px) scale(0.5)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.05)', opacity: 0, offset: 1 }
      ],
      { duration: 700, easing: 'cubic-bezier(0.3, 0.6, 0.35, 1)', fill: 'forwards' }
    );

    var cleanup = function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    };

    if (animation.finished && animation.finished.then) {
      animation.finished.then(function () {
        if (cartVisible) bounceCartIcon();
        cleanup();
      }).catch(cleanup);
    } else {
      animation.onfinish = function () {
        if (cartVisible) bounceCartIcon();
        cleanup();
      };
    }

    // Safety net in case the animation event never fires.
    setTimeout(cleanup, 1200);
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('js-product-form')) return;

    var sourceImage = findSourceImage(form);
    if (sourceImage) flyToCart(sourceImage);
  }, true);
})();
